import React from "react";

export const PrivacyPolicy = ({ setCurrentView }) => {
  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow-md">
        {/* Кнопка "Назад к регистрации" */}
        {setCurrentView && (
          <div className="mb-4">
            <button
              onClick={() => setCurrentView("home")}
              className="flex items-center text-blue-600 hover:text-blue-800 text-sm"
            >
              ← Назад к регистрации
            </button>
          </div>
        )}
        
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Политика конфиденциальности</h2>
          <p className="text-sm text-gray-500">Редакция от 16 октября 2026 года</p>
        </div>
        
        <div className="prose max-w-none text-gray-700 space-y-6">
          
          {/* 1. Общие положения */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">1. Общие положения</h3>
            <div className="bg-blue-50 p-4 rounded-lg space-y-2">
              <p>
                Настоящая Политика конфиденциальности регулирует обработку персональных данных пользователей 
                цифровой платформы Reversia.ru, оператором которой является 
                <strong>Сумченко О.А.</strong>, ИНН <strong>230808284051</strong> (далее — «Оператор»).
              </p>
              <p className="text-sm">
                <strong>Правовая основа:</strong> Федеральный закон №152-ФЗ «О персональных данных», 
                Федеральный закон №54-ФЗ «О применении ККТ».
              </p>
            </div>
          </div>

          {/* 2. Правовые основания обработки */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">2. Правовые основания обработки</h3>
            <div className="space-y-2">
              <p>Обработка персональных данных осуществляется на основании:</p>
              <ul className="list-disc list-inside space-y-1 text-sm">
                <li><strong>Согласие субъекта данных</strong> (ст. 6 152-ФЗ) — при регистрации в Сервисе</li>
                <li><strong>Исполнение договора</strong> (ст. 6 152-ФЗ) — для выполнения условий публичной оферты</li>
                <li><strong>Законные интересы оператора</strong> — обеспечение безопасности платформы</li>
                <li><strong>Соблюдение правовых обязательств</strong> — налоговая отчетность в соответствии с законодательством РФ</li>
              </ul>
            </div>
          </div>

          {/* 3. Обрабатываемые персональные данные */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">3. Обрабатываемые персональные данные</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-green-50 p-4 rounded">
                <h4 className="font-semibold text-green-800 mb-2">Пользователи (клиенты):</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>Имя, email, номер телефона</li>
                  <li>Геолокационные данные заданий</li>
                  <li>История платежей (через ЮКасса)</li>
                  <li>Загруженные медиафайлы</li>
                </ul>
              </div>
              
              <div className="bg-yellow-50 p-4 rounded">
                <h4 className="font-semibold text-yellow-800 mb-2">Исполнители (ИП и самозанятые):</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>ФИО, email, номер телефона</li>
                  <li>Реквизиты для выплат: номер телефона для СБП</li>
                  <li>Банковские реквизиты (наименование банка, БИК, расчётный и корреспондентский счёт) — по желанию исполнителя, на основании отдельного согласия</li>
                  <li>Рейтинги и отзывы</li>
                  <li>Портфолио и образцы работ</li>
                  <li>Паспортные данные и фотографии документов — только при добровольном прохождении верификации личности (см. п. 3.1)</li>
                </ul>
              </div>
            </div>

            <div className="mt-4 bg-blue-50 p-4 rounded border-l-4 border-blue-400">
              <h4 className="font-semibold text-blue-900 mb-2">3.1. Верификация личности Исполнителей</h4>
              <p className="text-sm mb-2">
                Исполнитель может <strong>добровольно</strong> пройти процедуру подтверждения личности по документу,
                удостоверяющему личность. Для отдельных категорий заданий (доступ к жилым помещениям, дачным участкам,
                личным вещам и документам Заказчика, уход за захоронениями) верификация является
                <strong> обязательным условием</strong> отклика на задание.
              </p>
              <p className="text-sm font-semibold mb-1">Какие данные собираются при верификации:</p>
              <ul className="list-disc list-inside text-sm space-y-1 mb-2">
                <li>ФИО, дата рождения</li>
                <li>Серия и номер паспорта, кем и когда выдан (по желанию), адрес регистрации (по желанию)</li>
                <li>Фотография разворота паспорта и фотография (селфи) с документом</li>
              </ul>
              <p className="text-sm font-semibold mb-1">Как обрабатываются данные:</p>
              <ul className="list-disc list-inside text-sm space-y-1 mb-2">
                <li>Обработка осуществляется только на основании <strong>отдельного явного согласия</strong> Исполнителя (ст. 9 152-ФЗ), которое даётся при подаче заявки</li>
                <li>Проверка проводится <strong>вручную уполномоченным сотрудником Оператора</strong>; автоматизированные системы и внешние (в том числе иностранные) сервисы распознавания НЕ применяются, трансграничная передача данных НЕ осуществляется</li>
                <li>Фотографии документов и номер паспорта хранятся <strong>в зашифрованном виде</strong> (криптографическое шифрование с изолированным ключом) на серверах в РФ</li>
                <li>После проверки в системе сохраняется только результат (подтверждено / отклонено) и маскированный номер документа (вида **** **1234); полный номер в открытом виде не хранится и не отображается</li>
                <li>Доступ к расшифрованным фотографиям имеет только администратор; каждое действие администратора фиксируется в журнале</li>
              </ul>
              <p className="text-sm">
                Отзыв согласия осуществляется в порядке, описанном в разделе 7. При отзыве согласия статус
                верификации аннулируется, фотографии документов удаляются.
              </p>
            </div>
            
            <div className="mt-4 bg-gray-50 p-4 rounded">
              <h4 className="font-semibold mb-2">Технические данные:</h4>
              <ul className="list-disc list-inside text-sm space-y-1">
                <li>IP-адрес, cookies (только необходимые для работы сервиса)</li>
                <li>Логи действий пользователей</li>
                <li>Метаданные загружаемых файлов</li>
              </ul>
              <p className="text-xs text-gray-600 mt-2">
                <strong>Важно:</strong> Банковские реквизиты исполнителей хранятся в зашифрованном виде 
                для оформления счетов и осуществления выплат. Данные банковских карт Оператор не запрашивает и не хранит. 
                Обработка входящих платежей осуществляется исключительно через YuKassa согласно их политике безопасности.
              </p>
            </div>
          </div>

          {/* 4. Сроки хранения данных */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">4. Сроки хранения данных</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-200 rounded-lg text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase">Тип данных</th>
                    <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase">Срок хранения</th>
                    <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase">Правовое основание</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="px-4 py-3 font-medium">Персональные данные пользователей</td>
                    <td className="px-4 py-3">5 лет после удаления аккаунта</td>
                    <td className="px-4 py-3">Ст. 23 НК РФ</td>
                  </tr>
                  <tr className="bg-yellow-50">
                    <td className="px-4 py-3 font-medium">История платежей и финансовые документы</td>
                    <td className="px-4 py-3 font-semibold text-yellow-700">5 лет</td>
                    <td className="px-4 py-3">Ст. 23 НК РФ</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-medium">Логи действий пользователей</td>
                    <td className="px-4 py-3">1 год</td>
                    <td className="px-4 py-3">Внутренние регламенты безопасности</td>
                  </tr>
                  <tr className="bg-gray-50">
                    <td className="px-4 py-3 font-medium">Медиафайлы выполненных заданий</td>
                    <td className="px-4 py-3">3 года или до удаления пользователем</td>
                    <td className="px-4 py-3">Договорные обязательства</td>
                  </tr>
                  <tr className="bg-blue-50">
                    <td className="px-4 py-3 font-medium">Фотографии документов (верификация личности)</td>
                    <td className="px-4 py-3 font-semibold text-blue-700">30 дней после решения по заявке, затем автоматическое удаление</td>
                    <td className="px-4 py-3">Принцип минимизации данных, ст. 5 152-ФЗ</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-medium">Результат верификации и маскированный номер документа</td>
                    <td className="px-4 py-3">На период использования Сервиса</td>
                    <td className="px-4 py-3">Согласие субъекта, обеспечение безопасности сделок</td>
                  </tr>
                  <tr className="bg-blue-50">
                    <td className="px-4 py-3 font-medium">Журнал действий администратора при верификации</td>
                    <td className="px-4 py-3">5 лет</td>
                    <td className="px-4 py-3">Внутренние регламенты безопасности, подотчётность обработки</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* 5. Цели обработки персональных данных */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">5. Цели обработки персональных данных</h3>
            <div className="space-y-3">
              <div className="bg-blue-50 p-3 rounded">
                <h4 className="font-semibold text-blue-800 mb-1">Основные цели:</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>Предоставление услуг платформы и исполнение договорных обязательств</li>
                  <li>Идентификация пользователей и обеспечение безопасности сервиса</li>
                  <li>Обработка платежей и взаимодействие с ЮКасса</li>
                  <li>Коммуникация между заказчиками и исполнителями</li>
                </ul>
              </div>
              
              <div className="bg-green-50 p-3 rounded">
                <h4 className="font-semibold text-green-800 mb-1">Финансовые операции:</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>Обработка платежей через систему YuKassa</li>
                  <li>Расчет и удержание комиссий платформы</li>
                  <li>Осуществление выплат исполнителям</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 6. Права субъектов персональных данных */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">6. Права субъектов персональных данных</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <h4 className="font-semibold mb-2">Ваши права согласно 152-ФЗ:</h4>
                <ul className="list-disc list-inside space-y-1 text-sm">
                  <li>Получать информацию об обработке ваших данных</li>
                  <li>Требовать уточнения, изменения или блокирования данных</li>
                  <li>Требовать удаления персональных данных</li>
                  <li>Отозвать согласие на обработку данных</li>
                  <li>Обратиться в Роскомнадзор при нарушении прав</li>
                </ul>
              </div>
              
              <div className="bg-red-50 p-3 rounded">
                <h4 className="font-semibold text-red-800 mb-2">Ограничения:</h4>
                <p className="text-sm">
                  Данные, <strong>обязательные для налоговой отчетности</strong> (ст. 6 152-ФЗ), 
                  не могут быть удалены до истечения сроков, установленных налоговым законодательством РФ.
                </p>
                <p className="text-xs text-gray-600 mt-2">
                  Это касается фискальных чеков, данных о выплатах самозанятым и комиссий платформы.
                </p>
              </div>
            </div>
          </div>

          {/* 7. Отзыв согласия */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">7. Порядок отзыва согласия</h3>
            <div className="bg-yellow-50 p-4 rounded border-l-4 border-yellow-400">
              <h4 className="font-semibold mb-2">Способы отзыва согласия:</h4>
              <ol className="list-decimal list-inside space-y-1 text-sm">
                <li>Через <strong>Личный кабинет</strong> → раздел «Приватность» → «Отозвать согласие»</li>
                <li>Письмо на <a href="mailto:support@reversia.ru" className="text-blue-600 hover:underline">support@reversia.ru</a> с темой «Отзыв согласия»</li>
                <li>Для GDPR (пользователи из ЕС): запрос с пометкой «GDPR Erasure»</li>
              </ol>
              
              <div className="mt-3 p-2 bg-white rounded text-xs">
                <p><strong>Сроки обработки:</strong></p>
                <ul className="list-disc list-inside">
                  <li>Стандартный запрос: до 30 дней (ст. 21 152-ФЗ)</li>
                  <li>GDPR запрос: до 30 дней согласно Регламенту ЕС</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 8. GDPR и локализация */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">8. GDPR и локализация данных</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-blue-50 p-4 rounded">
                <h4 className="font-semibold text-blue-800 mb-2">Локализация данных:</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>Все персональные данные хранятся на серверах в РФ (ст. 18 152-ФЗ)</li>
                  <li>Резервные копии также находятся на территории России</li>
                  <li>Передача данных за пределы РФ не осуществляется</li>
                </ul>
              </div>
              
              <div className="bg-purple-50 p-4 rounded">
                <h4 className="font-semibold text-purple-800 mb-2">GDPR соответствие:</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>Право на удаление данных (Right to Erasure)</li>
                  <li>Право на портативность данных</li>
                  <li>Уведомление о нарушениях в течение 72 часов</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 9. Cookies и техническая информация */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">9. Cookies и техническая информация</h3>
            <div className="bg-gray-50 p-4 rounded">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <h4 className="font-semibold mb-2">Используемые cookies:</h4>
                  <ul className="list-disc list-inside text-sm space-y-1">
                    <li><strong>Необходимые:</strong> аутентификация, безопасность</li>
                    <li><strong>Функциональные:</strong> настройки языка, сохранение предпочтений</li>
                    <li><strong>НЕ используем:</strong> рекламные, аналитические cookies</li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="font-semibold mb-2">Управление cookies:</h4>
                  <p className="text-sm">
                    Отключение через настройки браузера может привести к ограничению функциональности сервиса.
                  </p>
                  <p className="text-xs text-gray-600 mt-2">
                    Подробные настройки cookies доступны в настройках вашего браузера.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 10. Меры безопасности */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">10. Меры безопасности персональных данных</h3>
            <div className="space-y-3">
              <div className="bg-green-50 p-3 rounded">
                <h4 className="font-semibold text-green-800 mb-1">Технические меры:</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>SSL/TLS шифрование всех данных при передаче</li>
                  <li>Хеширование паролей с использованием bcrypt</li>
                  <li>Регулярные обновления системы безопасности</li>
                  <li>Мониторинг несанкционированного доступа 24/7</li>
                </ul>
              </div>
              
              <div className="bg-blue-50 p-3 rounded">
                <h4 className="font-semibold text-blue-800 mb-1">Организационные меры:</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li>Ограниченный доступ к персональным данным</li>
                  <li>Обучение персонала требованиям 152-ФЗ</li>
                  <li>Регулярный аудит систем обработки данных</li>
                  <li>Процедуры реагирования на инциденты</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 11. Передача данных третьим лицам */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">11. Передача данных третьим лицам</h3>
            <div className="space-y-3">
              <p>Персональные данные передаются третьим лицам только в следующих случаях:</p>
              
              <div className="bg-yellow-50 p-3 rounded">
                <h4 className="font-semibold text-yellow-800 mb-1">Уполномоченные третьи лица:</h4>
                <ul className="list-disc list-inside text-sm space-y-1">
                  <li><strong>ЮКасса</strong> — для обработки платежей (данные карт не передаются)</li>
                  <li><strong>ФНС России</strong> — налоговые данные ИП и самозанятых, фискальные чеки через YuKassa</li>
                  <li><strong>Роскомнадзор</strong> — по официальным запросам</li>
                </ul>
              </div>
              
              <p className="text-sm text-gray-600">
                Во всех остальных случаях передача данных осуществляется только с вашего 
                <strong> письменного согласия</strong> или по требованию законодательства РФ.
              </p>
            </div>
          </div>

          {/* 12. Контактная информация */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">12. Контактная информация</h3>
            <div className="bg-gray-50 p-4 rounded">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <h4 className="font-semibold mb-2">Оператор персональных данных:</h4>
                  <p><strong>ФИО:</strong> Сумченко О.А.</p>
                  <p><strong>ИНН:</strong> 230808284051</p>
                </div>
                
                <div>
                  <h4 className="font-semibold mb-2">Контакты для связи:</h4>
                  <p>
                    <strong>Email:</strong> 
                    <a href="mailto:support@reversia.ru" className="text-blue-600 hover:underline ml-1">
                      support@reversia.ru
                    </a>
                  </p>
                  <p><strong>Сайт:</strong> https://reversia.ru</p>
                  <p className="text-sm text-gray-600 mt-2">
                    <strong>Время ответа:</strong> в течение 3 рабочих дней с момента обращения
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Дата последнего обновления */}
          <div className="border-t pt-4 text-center text-xs text-gray-500">
            <p>Данная политика конфиденциальности вступила в силу 21.07.2025</p>
            <p>Последнее обновление: 08.07.2026 — добавлен раздел о верификации личности исполнителей (п. 3.1)</p>
            <p>Обновление от 4 августа 2026 года — уточнены реквизиты Оператора</p>
            <p>При внесении изменений пользователи уведомляются за 7 дней до вступления в силу</p>
          </div>

        </div>
      </div>
    </div>
  );
};

